'use client';
import { css, styled } from '@mui/material/styles';
export const AlertTitle = styled('div')(({ theme }) => css `
    color: ${theme.tokens.FuelColorTextPrimary};
    font-weight: ${theme.tokens.FuelFontWeightSemibold};
    line-height: ${theme.tokens.FuelLineHeightMd}; /* 150% */

    + .Alert-description {
        font-size:  ${theme.tokens.FuelFontSizeSm};
        line-height: ${theme.tokens.FuelLineHeightSm};
    }
`);
